/**
 * Serafina free tee auto-add
 *
 * Bxgy automatic discount "6 Month Studio Sale Free Tee" zero-prices the
 * Elevated Everyday Classic Tee in checkout when cart subtotal >= ₹2,600.
 * But Bxgy doesn't auto-ADD the tee to the cart — only zero-prices it
 * AFTER it's there. So the customer never sees the tee unless we add it
 * on their behalf when threshold is crossed.
 *
 * Identifies the gift line via line-item property `_free_gift: tee` so it
 * can be removed/swapped without confusing it with a paid tee.
 */
(function () {
  // ---- config ----
  var FREE_TEE_THRESHOLD = 260000; // 2,600 INR in paise (cart prices are in paise)
  var FREE_TEE_VARIANT_ID = 44028515188806; // Elevated Everyday Classic Tee — Black / M
  var GIFT_PROPERTY = '_free_gift';
  var GIFT_VALUE = 'tee';

  // ---- state ----
  var syncing = false;
  var lastSyncedAt = 0;

  function isGiftLine(item) {
    return !!(item && item.properties && item.properties[GIFT_PROPERTY] === GIFT_VALUE);
  }

  function getCartFetch() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function dispatchCartUpdate(cart) {
    // Mirrors Horizon's CartUpdateEvent ('cart:update') so cart-drawer + cart sections refresh.
    try {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'serafina-free-tee', data: { source: 'serafina-free-tee' } };
      document.dispatchEvent(ev);
    } catch (e) {
      console.warn('[serafina-free-tee] dispatch failed', e);
    }
    // Fallback drawer refresh used elsewhere in the theme.
    try {
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', { detail: { resource: cart } }));
    } catch (e) {}
  }

  function reloadIfOnCart() {
    if (window.location.pathname === '/cart' || window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return true;
    }
    return false;
  }

  function syncFreeTee() {
    if (syncing) return Promise.resolve();
    if (Date.now() - lastSyncedAt < 250) return Promise.resolve(); // debounce rapid events
    syncing = true;
    return getCartFetch()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return null;

        var giftLine = null;
        var subtotalExGift = 0;
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          if (isGiftLine(item)) giftLine = item;
          else subtotalExGift += (item.final_line_price || 0);
        }

        var unlocked = subtotalExGift >= FREE_TEE_THRESHOLD;

        if (unlocked && !giftLine) {
          return postJSON('/cart/add.js', {
            items: [{
              id: FREE_TEE_VARIANT_ID,
              quantity: 1,
              properties: (function () { var p = {}; p[GIFT_PROPERTY] = GIFT_VALUE; return p; })()
            }]
          }).then(function (res) {
            if (res && res.status && res.status >= 400) {
              console.warn('[serafina-free-tee] add failed', res);
              return null;
            }
            return getCartFetch().then(function (newCart) {
              if (reloadIfOnCart()) return newCart;
              dispatchCartUpdate(newCart);
              return newCart;
            });
          });
        }

        if (!unlocked && giftLine) {
          return postJSON('/cart/change.js', { id: giftLine.key, quantity: 0 }).then(function (newCart) {
            if (reloadIfOnCart()) return newCart;
            dispatchCartUpdate(newCart);
            return newCart;
          });
        }

        return cart;
      })
      .catch(function (e) {
        console.error('[serafina-free-tee] sync failed', e);
      })
      .then(function () {
        syncing = false;
        lastSyncedAt = Date.now();
      });
  }

  // Listen to Horizon's cart events
  document.addEventListener('cart:update', function (e) {
    // Skip if this update was dispatched by us — prevents recursion.
    if (e && e.detail && e.detail.sourceId === 'serafina-free-tee') return;
    syncFreeTee();
  });
  document.addEventListener('cart:refresh', syncFreeTee);
  document.addEventListener('cart-drawer:refresh', function (e) {
    if (e && e.detail && e.detail.resource && isGiftLineInCart(e.detail.resource)) return;
    syncFreeTee();
  });

  // ---- Gift size swap ----
  // User picks a different size on the free tee in /cart or cart drawer.
  // Atomic remove-old + add-new under the syncing lock so the auto-add
  // listener can't race in and re-add the old default variant.
  function changeGiftSize(selectEl) {
    if (syncing || !selectEl) return Promise.resolve();
    var newVariantId = parseInt(selectEl.value, 10);
    if (!newVariantId || newVariantId === FREE_TEE_VARIANT_ID && false) return Promise.resolve();

    syncing = true;
    selectEl.setAttribute('data-pending', '1');
    return getCartFetch()
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return null;
        var giftLine = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (isGiftLine(cart.items[i])) { giftLine = cart.items[i]; break; }
        }
        if (!giftLine) return null;
        if (giftLine.variant_id === newVariantId) return cart; // no-op
        return postJSON('/cart/change.js', { id: giftLine.key, quantity: 0 })
          .then(function () {
            return postJSON('/cart/add.js', {
              items: [{
                id: newVariantId,
                quantity: 1,
                properties: (function () { var p = {}; p[GIFT_PROPERTY] = GIFT_VALUE; return p; })()
              }]
            });
          })
          .then(function () { return getCartFetch(); });
      })
      .then(function (newCart) {
        if (!newCart) return null;
        if (reloadIfOnCart()) return newCart;
        dispatchCartUpdate(newCart);
        return newCart;
      })
      .catch(function (e) {
        console.error('[serafina-free-tee] size change failed', e);
      })
      .then(function () {
        syncing = false;
        lastSyncedAt = Date.now();
        selectEl.removeAttribute('data-pending');
      });
  }

  // Delegated change listener (re-attached automatically since cart re-renders the select)
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-serafina-gift-size]')) {
      changeGiftSize(t);
    }
  });

  function isGiftLineInCart(cart) {
    return Array.isArray(cart && cart.items) && cart.items.some(isGiftLine);
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncFreeTee);
  } else {
    syncFreeTee();
  }

  // Expose for manual debugging
  window.serafinaSyncFreeTee = syncFreeTee;
})();
